module.exports = __webpack_public_path__ + "static/media/32-10.cd8a1c5b.mp3";